const TIMETABLE_ACTION_TYPES = {
  FETCH: "FETCH_TIMETABLE",
  FETCH_REQUEST: "FETCH_TIMETABLE_REQUEST",
  FETCH_SUCCESS: "FETCH_TIMETABLE_SUCCESS",
  FETCH_FAILURE: "FETCH_TIMETABLE_FAILURE",
}

export default TIMETABLE_ACTION_TYPES
